var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLogo)?_c('img',{staticClass:"v-toolbar-logo",style:({
    height: _vm.styles.height
  }),attrs:{"src":_vm.logoUrl}}):_c('div',{class:['v-toolbar__text', { '--white': _vm.isWhiteTextColor }]},[_vm._v(" "+_vm._s(_vm.fallbackText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }